import { Pipe, PipeTransform } from "@angular/core";
import { EventosTipoEnum, obtenerNombreEventoTipo } from "@shared/enums";


@Pipe({
    name: "toStrEvent"
})
export class ToStrEventPipe implements PipeTransform {

    transform(value: EventosTipoEnum): string {
        return obtenerNombreEventoTipo(value);
    }

}
